module.exports = __webpack_public_path__ + "static/media/moveEnd.65f6c58d.gif";